export const AWAITING_SCORES = 'awaiting-scores';
export const AWAITING_SCORECARD = 'awaiting-scorecard';

export const FRONT_NINE_INDEX = [0, 1, 2, 3, 4, 5, 6, 7, 8];
export const BACK_NINE_INDEX = [9, 10, 11, 12, 13, 14, 15, 16, 17];

export const RYDER_CUP_TYPE = 'ryder-cup';
export const STABLEFORD_WITH_TEAM_GAMES = 'stableford-with-team-games';

export const TOURNAMENT_STATE_IN_PLAY = 'in-play';
export const TOURNAMENT_STATE_ARCHIVED = 'archived';

export const MATCH_FORMATS = {
  tierPoints_6_6_6: { id: 'tierPoints_6_6_6', name: 'Tier Points 6-6-6' },
  tierPoints_1_2_3: { id: 'tierPoints_1_2_3', name: 'Tier Points 1-2-3' },
  singles: { id: 'singles', name: 'Singles' },
  pairs: { id: 'pairs', name: 'Pairs' },
  stableford: { id: 'stableford', name: 'Stableford' },
};

export const IBIS = 'ibis';
export const SBM = 'sbm';
export const GROUPS = [IBIS, SBM];
